import { requestWithToken } from '../utilities/request';
import _ from 'lodash';

const path = '/api/private/fields/';

const mainSchedules = (fieldId, params) => {
  return requestWithToken({
    method: 'GET',
    url: `${path}${fieldId}/works/group_id_list`,
    params,
  });
};

const mainSchedulesTotal = (fieldId, params) => {
  return requestWithToken({
    method: 'GET',
    url: `${path}${fieldId}/works/list_total`,
    params,
  });
};

const mainSchedulesByPage = (
  fieldId,
  startDate,
  endDate,
  page,
  otherOptions
) => {
  const pageItemCount = 30;
  const offset = page * pageItemCount;
  let params = {
    date_from: startDate,
    date_to: endDate,
    offset,
  };
  if (otherOptions) {
    params = _.assign(otherOptions, params);
  }
  return mainSchedules(fieldId, params);
};

const schedules = (field_id, params) => {
  return requestWithToken({
    method: 'GET',
    url: `${path}${field_id}/works/list`,
    params,
  });
};

const groupWorkHours = (field_id, params) => {
  return requestWithToken({
    method: 'GET',
    url: `${path}${field_id}/works/group_sum_man_hours`,
    params,
  });
};

const groupEarlyHours = (field_id, params) => {
  return requestWithToken({
    method: 'GET',
    url: `${path}${field_id}/works/group_sum_early_hours`,
    params,
  });
};

const groupOverHours = (field_id, params) => {
  return requestWithToken({
    method: 'GET',
    url: `${path}${field_id}/works/group_sum_over_hours`,
    params,
  });
};

const histories = (fieldId, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/works/histories`),
    params: param,
  });
};

const getHistorySpt = (fieldId, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/works/history_spt`),
    params: param,
  });
};

const create = (fieldId, param) => {
  return requestWithToken({
    method: 'POST',
    url: path.concat(`${fieldId}/works`),
    data: param,
  });
};

const latestSchedule = (fieldId, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`${fieldId}/works/show_latest_schedule`),
    params: param,
  });
};

const copyWorks = (fieldId, workIds, date) => {
  return requestWithToken({
    method: 'POST',
    url: path.concat(`${fieldId}/works/copy_works`),
    data: {
      ids: workIds,
      work_date: date,
    },
  });
};

const reorder = (fieldId, workGroupId, workId, displayOrder) => {
  return requestWithToken({
    method: 'PUT',
    url: path.concat(`${fieldId}/works/${workId}/reorder`),
    data: {
      display_order: displayOrder,
      work_group_id: workGroupId,
    },
  });
};

const schedulesReflectOnHistories = (fieldId, date, workId) => {
  return requestWithToken(
    {
      method: 'POST',
      url: path.concat(`/${fieldId}/works/schedules_reflect_on_histories`),
      data: {
        work_date: date,
        work_id: workId,
      },
    },
    false
  );
};

const show = (fieldId, id) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`${fieldId}/works/${id}`),
  });
};

const deleteSchedule = (fieldId, id) => {
  return requestWithToken({
    method: 'DELETE',
    url: path.concat(`${fieldId}/works/${id}`),
  });
};

const checkBeforeDeletingWork = (fieldId, id) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`${fieldId}/works/${id}/check_before_deleting_work`),
  });
};

const abort = (fieldId, id) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(`${fieldId}/works/${id}/abort`),
  });
};

const resume = (fieldId, id) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(`${fieldId}/works/${id}/resume`),
  });
};

/**
 * 人工ダイアログからの更新と区別するため
 * 編集画面から呼び出す時はparamにfrom_work_edit: 1を指定する
 * それ以外(一覧画面など)ではfrom_work_editは不要
 *
 * from_work_edit:1があるとき職長ー職種の整合性チェックが行われる
 */
const update = (fieldId, id, param) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(`${fieldId}/works/${id}`),
    data: param,
  });
};

/**
 * workGroupIdに紐付くキープラン画像を検索する
 */
const getKeyPlanImage = ({
  fieldId,
  fieldTreeId,
  foremanUserId,
  jobId,
  workDate,
  workHourZone,
  scheduleFlag,
}) => {
  const params = {
    field_tree_id: fieldTreeId,
    foreman_user_id: foremanUserId,
    schedule_flag: scheduleFlag,
    job_id: jobId,
    work_date: workDate,
    work_hour_zone: workHourZone,
  };
  return requestWithToken({
    method: 'GET',
    url: `${path}${fieldId}/works/work_key_plan_image`,
    params,
  });
};

const updateBatchWork = (fieldId, data) => {
  return requestWithToken({
    method: 'PATCH',
    url: `${path}${fieldId}/works/multiple_update`,
    data,
  });
};

const multipleUpdateWork = (fieldId, data) => {
  return requestWithToken({
    method: 'PATCH',
    url: `${path}${fieldId}/works/multiple_update`,
    data,
  });
};

const getWorkByIds = (fieldId, data) => {
  return requestWithToken({
    method: 'POST',
    url: `${path}${fieldId}/works/list_for_multiple_updated_works`,
    data,
  });
};

const getCountReflectWork = (fieldId, params) => {
  return requestWithToken({
    method: 'GET',
    url: `${path}${fieldId}/works/count_reflect_work`,
    params,
  });
};

const getNotReflectWorks = (fieldId, params) => {
  return requestWithToken({
    method: 'GET',
    url: `${path}${fieldId}/works/list_unreflect_works`,
    params,
  });
};

const getUnapprovedCount = (fieldId) => {
  return requestWithToken({
    method: 'GET',
    url: `${path}${fieldId}/works/unapproved_count`,
  });
};

export const WorkScheduleService = {
  mainSchedules,
  mainSchedulesTotal,
  mainSchedulesByPage,
  schedules,
  groupWorkHours,
  groupEarlyHours,
  groupOverHours,
  histories,
  getHistorySpt,
  create,
  latestSchedule,
  schedulesReflectOnHistories,
  copyWorks,
  reorder,
  show,
  deleteSchedule,
  checkBeforeDeletingWork,
  abort,
  resume,
  update,
  getKeyPlanImage,
  updateBatchWork,
  multipleUpdateWork,
  getWorkByIds,
  getCountReflectWork,
  getNotReflectWorks,
  getUnapprovedCount,
};

export default WorkScheduleService;



// WEBPACK FOOTER //
// ./src/services/Works.js